import { z } from 'zod';

export const routingSettingsSchema = z
    .object({
        electric: z.boolean(),
        height_m: z.number().finite().min(0.1).max(10),
        width_m: z.number().finite().min(0.1).max(10),
        length_m: z.number().finite().min(0.1).max(50),
        gross_weight_kg: z.number().finite().min(1).max(100000),
        current_weight_kg: z.number().finite().min(1).max(100000),
        axle_weight_kg: z.number().finite().min(1).max(30000),
        vehicle_axles: z.number().finite().min(2).max(10).int(),
        trailer_axles: z.number().finite().min(0).max(10).int(),
        cost_per_km: z.number().finite().min(0).max(100),
        battery_kwh: z.number().finite().min(1).max(2000),
        initial_charge_percent: z.number().finite().min(1).max(100),
        reserve_percent: z.number().finite().min(1).max(99),
        target_charge_percent: z.number().finite().min(2).max(100),
        charging_power_kw: z.number().finite().min(1).max(2000),
        consumption_kwh_per_km: z.number().finite().min(0.01).max(10),
        tunnel_category: z.enum(['none', 'B', 'C', 'D', 'E']),
        hazardous_goods: z.enum([
            'none',
            'explosive',
            'gas',
            'flammable',
            'combustible',
            'organic',
            'poison',
            'radioActive',
            'corrosive',
            'poisonousInhalation',
            'harmfulToWater',
            'other',
        ]),
        emission_type: z.enum(['euro6', 'euro5', 'euro4']),
    })
    .refine(
        v =>
            v.current_weight_kg <= v.gross_weight_kg &&
            v.reserve_percent < v.initial_charge_percent &&
            v.reserve_percent < v.target_charge_percent
    );

export type RoutingSettings = z.infer<typeof routingSettingsSchema>;
export const DEFAULT_ROUTING_SETTINGS: RoutingSettings = {
    electric: false,
    height_m: 4,
    width_m: 2.55,
    length_m: 16.5,
    gross_weight_kg: 40000,
    current_weight_kg: 30000,
    axle_weight_kg: 8500,
    vehicle_axles: 2,
    trailer_axles: 3,
    cost_per_km: 0.3,
    battery_kwh: 300,
    initial_charge_percent: 60,
    reserve_percent: 10,
    target_charge_percent: 90,
    charging_power_kw: 200,
    consumption_kwh_per_km: 1.3,
    tunnel_category: 'none',
    hazardous_goods: 'none',
    emission_type: 'euro6',
};
